import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  order: 5;
  margin: 80px 0px 0px !important;
  padding: 0px 20px !important;

  ${media.md`
    margin: 75px 0px 0px !important;
    padding: 0px 60px !important;
  `}

  ${media.xl`
    max-width: 1060px !important;
    margin: 75px auto 0px !important;
    padding: 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding: 0px !important;

  ${media.md`
    justify-content: start;
    align-items: center;
    flex-direction: row-reverse;
    gap: 50px;
  `}

  ${media.lg`
    flex-direction: row-reverse;
   
    gap: 50px;
  `}
`;

export const ImageSection = styled.div`
  width: 100%;
  display: flex;

  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: var(--Orange-50, #faf2e8);
  border-radius: 16.463px;

  ${media.md`
   
    height: 260px !important;
    width: 100% !important;

  `}
  ${media.lg`
    width: calc(53.3% - 25px) !important;
    height: 370px !important;
  `}
  ${media.xl`
    
    width: 540px !important;
    height: 370px !important;
   
  `}
`;

export const Image = styled.img`
  width: 246px;
  height: 189px;
  margin-top: -15px;

  ${media.md`
    width: 312px;
    height: 240px;
    margin-top:-60px;
    position: absolute;



  `}
  ${media.lg`
    width: 458px;
    height: 352px;
    margin-top:-60px;
  `};
`;

// export const Video = styled.video`
//   display: ${props => props.display || 'block'};
//   width: 178.195px;
//   height: 221.855px;
//   position: absolute;
//   top: -58px;
//   left: 50%;
//   transform: translateX(-50%);

//   ${media.lg`
//     width: 353px;
//     height: 439px;
//     top: -28px;
//   `}
// `;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  ${media.md`
    width: 100%;
    
  `}

  ${media.lg`
    width: calc(46.7% - 25px);
    justify-content: center;
  `}
`;

export const Title = styled.h3`
  color: #1c1c1c;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 34px;
  font-weight: 900;
  line-height: 87%;
  letter-spacing: -0.68px;

  text-transform: uppercase;
  margin: 0px;

  ${media.xl`
    font-size: 46px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -0.92px;
  `}
`;

export const Text = styled.p`
  color: #797b8b;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 435;
  line-height: 123%;
  margin: 10px 0px 0px;

  ${media.xl`
    font-size: 22px;
    font-weight: 500;
    line-height: 123%;
    margin: 20px 0px 0px;
  `}
`;

export const InstructionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 10px;
  margin: 20px 0px 0px;

  ${media.lg`
    gap: 25px;
    margin: 25px 0px 0px;
  `}
`;

export const InstructionContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: #f0f0f5;
  border-radius: 10px;
  padding: 15px;
  gap: 10px;
  margin: 0px;

  ${media.md`
    justify-content: start;
    align-items: center;
  `}

  ${media.lg`
    justify-content: start;
    align-items: start;
    background: none;
    border-radius: 0px;
    padding: 0px;
  `}
`;

export const InstructionTitle = styled.h4`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 754;
  line-height: 123%;
  white-space: break-spaces;
  margin: 0px;

  ${media.xl`
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
  `}
`;

export const InstructionText = styled.p`
  color: #797b8b;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 435;
  line-height: 123%;
  display: contents;
  margin: 0px;

  ${media.xl`
    font-size: 18px;
    font-weight: 500;
    line-height: 150%;
  `}
`;

export const Button = styled.a`
  background: var(--Primary-Satoshi-Orange, #f7931a);
  border-radius: 116.162px;
  padding: 14px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  gap: 9.293px;
  height: 20px;
  color: var(--Shades-900, #1c1c1c);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 110%;
  text-align: center;
  margin: 20px 0px 0px;
  cursor: pointer;
  text-decoration: none;
  align-self: stretch;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  ${media.md`
    margin: 25px 0px 0px;
    align-self: unset;
    
  `}

  ${media.xl`
  
    margin: 50px 0px 0px;
    padding: 14px 28px;
  `}
`;

export const Buttonwrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const Orangecircle = styled.img`
  width: 28px;
  height: 28px;
`;
